//-------------------------------------------------------------------------------------------
// Abide radio selected validation
// Usage(s): Priority List From
//-------------------------------------------------------------------------------------------
import Foundation from 'foundation-sites';

Foundation.Abide.defaults.validators['validate-radio-selection'] = validateRadioSelection;

function validateRadioSelection(
    $el,      /* jQuery element to validate */
    required, /* is the element required according to the `[required]` attribute */
    parent    /* parent of the jQuery element `$el` */
) {
    var parent_selector = $el.attr('data-parent-selector');
    var radio_selector = $el.attr('data-radio-selector');

    var parentElement = $(parent_selector);
    if (parentElement.length > 0) {
        parentElement = $(parentElement[0]);
    }

    if (!parentElement) {
        console.error('validateRadioSelection - parent element not found');
    }

    var radioElements = parentElement.find(radio_selector);

    if (!radioElements) {
        console.error('validateRadioSelection - radio elements not found: ' + radio_selector);
    }

    var selectedRadios = parentElement.find(radio_selector + ":checked");
    var valid = selectedRadios && selectedRadios.length > 0;
    
    if (valid) {
        parentElement.removeClass('invalid-no-selection');
        showFormErrorChildren(parentElement, '');
        $el.attr("aria-invalid", "false");
    } else {
        parentElement.addClass('invalid-no-selection');
        showFormErrorChildren(parentElement, 'invalid-no-selection');
        $el.attr("aria-invalid", "true");
    }

    return valid;
};

function showFormErrorChildren($parent, className)
{
    var children = $parent.children(".form-error");
    if (children.length)
    {
        for (var i=0; i < children.length; i++)
        {
            if (children[i].classList.contains(className))
            {
                children[i].classList.remove("is-hidden");
                children[i].classList.add("is-visible");
            } else {
                children[i].classList.add("is-hidden");
                children[i].classList.remove("is-visible");
            }
        }
    }
}
